import { Label } from '@lego/connect-components-react';
import type { MultiValue } from 'chakra-react-select';
import { useState } from 'react';
import Combobox, {
  type ComboboxSize,
  type DefaultOptionType,
} from './combobox';
import { useFilteredGroups } from './combobox-queries';

type GroupsComboboxProps = {
  selectedItems: DefaultOptionType[];
  onSelect: (items: MultiValue<DefaultOptionType>) => void;
  size?: ComboboxSize;
};

const GroupsCombobox = ({
  selectedItems,
  onSelect,
  size = 'medium',
}: GroupsComboboxProps) => {
  const [searchValue, setSearchValue] = useState('');
  const { data, isFetching } = useFilteredGroups(searchValue);
  return (
    <div>
      <Label>Groups</Label>
      <Combobox
        options={
          data?.map((item) => ({
            id: item.idAsString,
            label: `${item.name !== '' ? item.name : 'N/A'} - ${item.idAsString}`,
          })) || []
        }
        selectedItems={selectedItems}
        isLoading={isFetching}
        onSelect={(selectedItems) => onSelect(selectedItems)}
        inputValue={searchValue}
        onInputChange={(value: string) => setSearchValue(value)}
        placeholder="Start typing group to search"
        size={size}
      />
    </div>
  );
};
export default GroupsCombobox;
